module.exports = __webpack_public_path__ + "img/group.158c7f2b.svg";